import React from 'react'
import { ArticlesCategoriesLoader } from 'loaders'
import PropTypes from 'prop-types'
import ArticleCreateContainer from './ArticleCreateContainer'

const ArticleCreate = ({ history, location, match }) => (
  <ArticlesCategoriesLoader>
    <ArticleCreateContainer
      history={history}
      location={location}
      match={match}
    />
  </ArticlesCategoriesLoader>
)

ArticleCreate.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    fromUrl: PropTypes.string,
    fromPathname: PropTypes.string,
  }).isRequired,
}

export default ArticleCreate
